import usePrivateAxios from '@/common/api/usePrivateAxios'
import { getRailsUpdate } from '@/common/utils/getRailsUpdate'
import { mapToDeletion } from '@/common/utils/railsHelpers'
import { EquipmentCategoryValidationSchema } from '@/features/equipmentCategories/schemas/equipmentCategory.schema'
import { EquipmentCategoryData } from '@/features/equipmentModels/types/equipmentCategories'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

interface UseUpdateEquipmentCategoryProps {
  equipmentCategoryId?: string
  initialEquipmentCategory?: EquipmentCategoryData
  onSuccess: () => void
  onError: (error: AxiosError) => void
}

export const useUpdateEquipmentCategory = ({
  equipmentCategoryId,
  initialEquipmentCategory,
  onSuccess,
  onError,
}: UseUpdateEquipmentCategoryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEquipmentCategory'],
    mutationFn: async (form: EquipmentCategoryValidationSchema) => {
      const payload = {
        ...form,
        equipment_tier_id: form.equipment_tier?.value || null,
        max_tank_capacity: Number(form.max_tank_capacity.replace(/\D/g, '')),
        driver_license_category_equipment_categories_attributes: getRailsUpdate(
          initialEquipmentCategory?.driver_license_category_equipment_categories || [],
          form.driver_license_category_equipment_categories || [],
          (value) => value.driver_license_category.id,
          (value) => value.value || '',
          mapToDeletion,
          (value) => ({driver_license_category_id: value.value})
        )
      }

      const { equipment_tier, driver_license_category_equipment_categories, ...cleanPayload} = payload

      return privateAxios.put(`/equipment_categories/${equipmentCategoryId}`, { equipment_category: cleanPayload })
    },
    onSuccess,
    onError,
  })
}
